import { AbstractError } from '@/domain/errors/abstract-error.js';

export class ForbiddenError extends AbstractError {
    public readonly code = 403;
    constructor(message = 'Forbidden', args?: string[]) {
        super(message, args);
    }
}
